import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { StartAgentTunnelSessionResData } from "./StartAgentTunnelSessionResData";

const ENDPOINT = "/remotelink/session/start";

export class StartAgentTunnelSessionCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: StartAgentTunnelSessionReqData;

    constructor(installationName: string, serialNumbers: Array<string>, protocolPort: number, secureConnection: boolean) {
        super();
        this.payload = new StartAgentTunnelSessionReqData(installationName, serialNumbers, protocolPort, secureConnection);
    }

    public async execute(): Promise<StartAgentTunnelSessionResData> {
        let res = await this.executeCommand(this.payload);
        return new StartAgentTunnelSessionResData(res);
    }
}

export class StartAgentTunnelSessionReqData {
    installationName: string;
    serialNumbers: Array<string>;
    servicePort: number;
    secureConnection: boolean;

    constructor(installationName: string, serialNumbers: Array<string>, protocolPort: number, secureConnection: boolean) {
        this.installationName = installationName;
        this.serialNumbers = serialNumbers;
        this.servicePort = protocolPort;
        this.secureConnection = secureConnection;
    }
}
